export const getFormattedNumber = (number: Number) => {
  const numberAsString = number.toLocaleString("en-US");
  const formattedString = numberAsString.replaceAll(",", " ");
  return formattedString;
};

export const convertToInternationalNumberSystem = (number: Number) => {
  let isNegativeNumber = number < 0;
  let formattedNumber = ''; 

  if (Math.abs(Number(number)) >= 1.0e+9) {
    formattedNumber = (Math.abs(Number(number)) / 1.0e+9).toFixed(2).replace(".00", '') + "B";
  }
  else if (Math.abs(Number(number)) >= 1.0e+6) {
    formattedNumber = (Math.abs(Number(number)) / 1.0e+6).toFixed(2).replace(".00", '') + "M"
  }
  else if (Math.abs(Number(number)) >= 1.0e+3) {
    formattedNumber = (Math.abs(Number(number)) / 1.0e+3).toFixed(2).replace(".00", '') + "K"
  }
  else {
    formattedNumber = Math.abs(Number(number)).toString();
  }

  if (isNegativeNumber) {
    formattedNumber = '-' + formattedNumber;
  }

  return formattedNumber;

  // There is also a library which also does the same formatting.
  // return new Intl.NumberFormat('en-GB', { notation: "compact", compactDisplay: "short" }).format(Number(number));
  // But we decided to write this converter manually so that we have more control over the code and the library also have some support
  // issues with IE 11.
  // Link: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat
}

